var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "30px",
    viewBox: "0 0 47 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "team") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_00",
    transform: "translate(-1023.000000, -421.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(145.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M906.447154,130 C904.685628,130 903.170738,129.416672 901.902439,128.249997 C900.63414,127.083328 900,125.666675 900,124 C900,122.333325 900.63414,120.916672 901.902439,119.750003 C903.170738,118.583328 904.685628,118 906.447154,118 C908.279144,118 909.829262,118.583328 911.097561,119.750003 C912.36586,120.916672 913,122.333325 913,124 C913,125.666675 912.36586,127.083328 911.097561,128.249997 C909.829262,129.416672 908.279144,130 906.447154,130 Z M889.552846,130 C887.720856,130 886.170738,129.416672 884.902439,128.249997 C883.63414,127.083328 883,125.666675 883,124 C883,122.333325 883.63414,120.916672 884.902439,119.750003 C886.170738,118.583328 887.720856,118 889.552846,118 C891.314372,118 892.829262,118.583328 894.097561,119.750003 C895.36586,120.916672 896,122.333325 896,124 C896,125.666675 895.36586,127.083328 894.097561,128.249997 C892.829262,129.416672 891.314372,130 889.552846,130 Z M880.104167,136.991935 C883.50696,135.66397 886.77082,135 889.895833,135 C893.020847,135 896.319427,135.66397 899.791667,136.991935 C903.263907,138.319901 905,140.102139 905,142.33871 L905,148 L875,148 L875,142.33871 C875,140.102139 876.701372,138.319901 880.104167,136.991935 Z M906.80625,136 C910.347935,136 913.765608,136.495571 917.059378,137.486726 C920.353142,138.477881 922,140.070787 922,142.265487 L922,148 L908.4,148 L908.4,142.265487 C908.4,140.778754 908.152086,139.628324 907.65625,138.814163 C907.160414,137.999994 906.275007,137.09735 905,136.106195 C905.495836,136.035396 906.097914,136 906.80625,136 Z",
    id: "team"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.537daaf32dec5606f7ed6be170c2890c.svg";
export { ForwardRef as ReactComponent };